<template>
  <app-inline-alert permanent variant="info">
    Требования к безопасности пароля:
    <table>
      <tr>
        <td>
          <i :class="['bx', requirements.length ? 'bx-check' : 'bx-x', 'mr-0']"></i>
        </td>
        <td>Длина пароля не меньше 14 символов</td>
      </tr>
      <tr>
        <td>
          <i :class="['bx', requirements.lettersLower ? 'bx-check' : 'bx-x', 'mr-0']"></i>
        </td>
        <td>Должны быть английские строчные буквы: a-z</td>
      </tr>
      <tr>
        <td>
          <i :class="['bx', requirements.lettersUpper ? 'bx-check' : 'bx-x', 'mr-0']"></i>
        </td>
        <td>Должны быть заглавные английские буквы: A-Z</td>
      </tr>
      <tr>
        <td>
          <i :class="['bx', requirements.digit ? 'bx-check' : 'bx-x', 'mr-0']"></i>
        </td>
        <td>Должна быть хотя бы одна цифра: 0-9</td>
      </tr>
      <tr>
        <td>
          <i :class="['bx', requirements.special ? 'bx-check' : 'bx-x', 'mr-0']"></i>
        </td>
        <td>Должен быть хотя бы 1 спецсимвол: ! " # $ % & ' () * +, -./ : ; &lt; = &gt; ? @ [ ] \ ^ - {{}} ~</td>
      </tr>
    </table>
  </app-inline-alert>
</template>

<script>
import AppInlineAlert from '@/components/notifications/AppInlineAlert';

export default {
  name: 'PasswordRequirements',
  components: { AppInlineAlert },
  props: {
    password: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      requirements: {
        length: false,
        lettersLower: false,
        lettersUpper: false,
        digit: false,
        special: false
      }
    };
  },
  computed: {
    isValid() {
      return (
        this.requirements.length &&
        this.requirements.lettersLower &&
        this.requirements.lettersUpper &&
        this.requirements.digit &&
        this.requirements.special
      );
    }
  },
  watch: {
    password() {
      this.validatePassword();
    },
    isValid(newVal) {
      this.$emit('is-valid', newVal);
    }
  },
  created() {
    this.validatePassword();
  },
  methods: {
    validatePassword() {
      this.requirements.length = this.password.length >= 14;
      this.requirements.lettersLower = /[a-z]/.test(this.password);
      this.requirements.lettersUpper = /[A-Z]/.test(this.password);
      this.requirements.digit = /\d/.test(this.password);
      this.requirements.special = /[!"#$%&'()*+,-./:;<=>?@[\]\\^_`{|}~]/.test(this.password);
      this.$emit('is-valid', this.isValid);
    }
  }
};
</script>
